// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-select {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: inherit;
  font-size: 0.85rem;
}

.language-select__label {
  color: inherit;
  opacity: 0.78;
  white-space: nowrap;
}

.language-select select {
  min-width: 92px;
  max-width: 100%;
  height: 34px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.1);
  color: inherit;
  padding: 0 28px 0 10px;
}

.language-select select:focus {
  outline: 2px solid rgba(59, 130, 246, 0.45);
  outline-offset: 2px;
}

.language-select--sidebar {
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
}

.language-select--sidebar select {
  flex: 0 0 auto;
}

.language-select--compact select {
  min-width: 54px;
  padding-left: 6px;
  padding-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/LanguageSelect.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".language-select {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  color: inherit;\n  font-size: 0.85rem;\n}\n\n.language-select__label {\n  color: inherit;\n  opacity: 0.78;\n  white-space: nowrap;\n}\n\n.language-select select {\n  min-width: 92px;\n  max-width: 100%;\n  height: 34px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  border-radius: 7px;\n  background: rgba(255, 255, 255, 0.1);\n  color: inherit;\n  padding: 0 28px 0 10px;\n}\n\n.language-select select:focus {\n  outline: 2px solid rgba(59, 130, 246, 0.45);\n  outline-offset: 2px;\n}\n\n.language-select--sidebar {\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.language-select--sidebar select {\n  flex: 0 0 auto;\n}\n\n.language-select--compact select {\n  min-width: 54px;\n  padding-left: 6px;\n  padding-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
